import { ActivityComponentType } from '@stackflow/react'
import { QueryClient } from '@tanstack/react-query'
import { useContext, useEffect, useState } from 'react'
import apis from '../../../modules/apis'
import { axiosGet } from '../../../modules/axiosHelper'
import {
  MaterialSubTab,
  TextContext,
  TextProvider,
  fetchMaterial,
} from '../../../pages/[lang]/portal/materials/detail/[materialId]'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'
import MaterialBodyComponent from '../../new-portal/materials/MaterialBodyComponent'
import WebviewStackContainer from '../common/WebviewStackContainer'

interface IMaterialDetail {
  params: {
    materialId: string
  }
}

const MaterialViewActivity: ActivityComponentType = ({ params }: IMaterialDetail) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const [materialData, setMaterialData] = useState(null)
  const [activeTabIdx, setActiveTabIdx] = useState<number>(0)
  const { showKorean, setShowKorean, textSize, setTextSize } = useContext(TextContext)

  const getMaterailData = async () => {
    const queryClient = new QueryClient()

    const [_, json] = await Promise.all([
      queryClient.prefetchQuery(['material', params.materialId], () => fetchMaterial(params.materialId)),
      axiosGet(apis.course.detail({ id: params.materialId })),
    ])

    if (json.success) {
      setMaterialData(json)
    }
  }

  useEffect(() => {
    getMaterailData()
  }, [])

  return (
    <TextProvider>
      <WebviewStackContainer
        onBack={pop}
        title={
          materialData && !showKorean
            ? materialData?.course?.title_en
              ? materialData?.course?.title_en
              : materialData?.course?.title
            : materialData?.course?.title_kr
            ? materialData?.course?.title_kr
            : materialData?.course?.title
        }
      >
        <MaterialSubTab activeTabIdx={activeTabIdx} setActiveTabIdx={setActiveTabIdx} />
        {materialData && (
          <div className="relative mt-[20px] h-screen">
            <MaterialBodyComponent
              activeTabIdx={activeTabIdx}
              materialData={materialData}
              materialId={params.materialId}
            />
          </div>
        )}
      </WebviewStackContainer>
    </TextProvider>
  )
}

export default MaterialViewActivity
